// src/components/pages/Pricing.js
import { useState, useEffect } from 'react';
import BillingCard from '../BillingCard';
import PaymentModal from '../PaymentModal';
import Footer from '../Footer';

/*────────────────────────── plan catalogue ─────────────────────────*/
export const PLANS = {
  trial: {
    key             : 'trial',
    title           : 'Trial',
    subtitle        : 'Get a feel for our data',
    monthlyPriceTxt : 'Free',
    yearlyPriceTxt  : 'Free',
    monthlyCredits  : 5,
    yearlyCredits   : 60,      // 5 × 12 months
    features        : ['5 trial searches', 'Basic company data']
  },

  basic: {
    key             : 'basic',
    title           : 'Basic',
    subtitle        : 'Ideal for light users',
    // replace these IDs with your actual Stripe price IDs for $24/mo and $240/yr
    monthlyPriceId  : '<YOUR_BASIC_MONTHLY_PRICE_ID>',
    yearlyPriceId   : '<YOUR_BASIC_YEARLY_PRICE_ID>',
    monthlyPriceTxt : '$24',
    yearlyPriceTxt  : '$240',  // 2 months free if you charge 10× monthly
    monthlyCredits  : 200,
    yearlyCredits   : 2400,    // 200 × 12 months
    features        : [
      'Business name',
      'Phone number',
      'Website URL'
    ]
  },

  professional: {
    key             : 'professional',
    title           : 'Professional',
    subtitle        : 'Reviews, rankings & tech data',
    // replace these with your new $50/mo and $500/yr price IDs
    monthlyPriceId  : '<YOUR_PRO_MONTHLY_PRICE_ID>',
    yearlyPriceId   : '<YOUR_PRO_YEARLY_PRICE_ID>',
    monthlyPriceTxt : '$50',
    yearlyPriceTxt  : '$500',
    monthlyCredits  : 500,
    yearlyCredits   : 6000,    // 500 × 12
    features        : [
      'All Basic features',
      'Postal address',
      'Google ranking'
    ]
  },

  enterprise: {
    key             : 'enterprise',
    title           : 'Enterprise',
    subtitle        : 'Heavy-duty prospecting',
    // replace these with your new $80/mo and $800/yr price IDs
    monthlyPriceId  : '<YOUR_ENT_MONTHLY_PRICE_ID>',
    yearlyPriceId   : '<YOUR_ENT_YEARLY_PRICE_ID>',
    monthlyPriceTxt : '$80',
    yearlyPriceTxt  : '$800',
    monthlyCredits  : 1500,
    yearlyCredits   : 18000,   // 1500 × 12
    features        : [
      'All Professional features',
      'Priority scraping queue',
      'Dedicated support'
    ]
  }
};

const Pricing = ({ user }) => {
  const [billingCycle, setBillingCycle] = useState('monthly'); 
  const [showModal,    setShowModal]    = useState(false);
  const [modalPlanKey, setModalPlanKey] = useState('');
  const [modalPriceId, setModalPriceId] = useState('');

  useEffect(() => {
    document.body.style.overflow = showModal ? 'hidden' : 'unset';
  }, [showModal]);

  const openModal = planKey => {
    if (!user?.email && planKey !== 'trial') {
      return window.location = '/signup';
    }

    if (planKey === 'trial') {
      // Trial is free—no Stripe
      return window.location = '/signup';
    }

    const id = billingCycle === 'monthly'
      ? PLANS[planKey].monthlyPriceId
      : PLANS[planKey].yearlyPriceId;

    setModalPlanKey(planKey);
    setModalPriceId(id);
    setShowModal(true);
  };

  return (
    <>
      <div className="pricing-page">
        <h1 className="hero-text">Pricing</h1>
        <p className="sub-hero-text">How many leads are right for you?</p>

        <div className="billing-options-container">
          {['monthly','yearly'].map(cycle =>
            <button
              key={cycle}
              onClick={() => setBillingCycle(cycle)}
              className={billingCycle === cycle ? 'selected' : ''}>
              {cycle === 'monthly' ? 'Monthly Billing' : 'Yearly Billing'}
            </button>
          )}
        </div>

        <div className="billing-cards-container">
          {Object.values(PLANS).map(plan =>
            <BillingCard
              key       ={plan.key}
              title     ={plan.title}
              subtitle  ={plan.subtitle}
              price     ={plan.key === 'trial'
                            ? plan.monthlyPriceTxt
                            : billingCycle === 'monthly'
                              ? plan.monthlyPriceTxt
                              : plan.yearlyPriceTxt}
              features  ={[
                billingCycle === 'monthly'
                  ? `${plan.monthlyCredits} searches / mo`
                  : `${plan.yearlyCredits} searches / yr`,
                ...plan.features
              ]}
              subscribeClick={() => openModal(plan.key)}
            />
          )}
        </div>
      </div>

      {showModal &&
        <PaymentModal
          close   ={() => setShowModal(false)}
          planKey ={modalPlanKey}
          priceId ={modalPriceId}
          user    ={user}
        />
      }
      <Footer/>
    </>
  );
};

export default Pricing;
